import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import SettingsPreferredRatePreferredRate from 'lumen/components/settings/preferred-rate/preferred-rate';
import type HotelSettingPreferredRateController from 'lumen/controllers/hotel/settings/preferred-rate';

interface HotelSettingPreferredRateSignature {
  Args: {
    controller: HotelSettingPreferredRateController;
    model: unknown;
  };
}

<template>
  {{#if
    (or
      @controller.model.saveAndUpdatePreferredRateSettings.isRunning
      @controller.model.requestPricingAssistantRatePreferencesOptionsTaskResult.isRunning
      @controller.model.launchRatePreferenceSimulateRequestTask.isRunning
    )
  }}
    <PrismLoadingBar />
  {{/if}}

  {{#unless
    @controller.model.requestPricingAssistantRatePreferencesOptionsTaskResult.isRunning
  }}
    <SettingsPreferredRatePreferredRate
      @hasUserChangedPreferredRateSettingsValue={{@controller.hasUserChangedPreferredRateSettingsValue}}
      @model={{@controller.model}}
      @updateHasUserChangedPreferredRateSettingsValue={{@controller.updateHasUserChangedPreferredRateSettingsValue}}
    />
  {{/unless}}
</template> satisfies TOC<HotelSettingPreferredRateSignature>;
